// Dependencies
import React from 'react';

// Local Components
import CardCta from '../../../card-cta/card-cta';
import GuideSignUpCta from '../../../guide-sign-up-cta/guide-sign-up-cta';

type COLMembershipCtaProps = {
  identity: Record<string, any>;
  trackingId?: string;
  impressionPayload?: Record<string, any>;
};

const COLMembershipCta = ({
  identity,
  trackingId = 'COLMembershipCta',
  impressionPayload = {},
}: COLMembershipCtaProps): JSX.Element => {
  const isSignedIn = identity?.isSignedIn;
  const creditScore =
    identity?.profiles?.tu_credit_report_profile?.vantage_score_3;

  const propsSignUpCta = {
    ctaTitle: 'Afford the city you want to live in',
    ctaSubtitle:
      'Get free guidance on changes you can make to afford more home, without spending more.',
    flowCopy: 'Afford the life you want',
    trackingId,
  };

  const propsCardCta = creditScore
    ? {
        // With credit score
        iconName: 'House_pricetag',
        title: 'How is your credit doing?',
        children: (
          <span>
            NerdWallet actively monitors your credit report and gives you
            actions to improve your credit. Check out your{' '}
            <a href="/home/dashboard/credit-score" target="_blank">
              credit dashboard
            </a>
            .
          </span>
        ),
        trackingId,
      }
    : {
        // Without credit score
        iconName: 'House_pricetag',
        title: 'Afford more by improving your credit score',
        children: (
          <span>
            Your credit score is one of the biggest factors that can make an
            unaffordable city affordable, by lowering the cost of home
            ownership. You can get your{' '}
            <a href="/home/dashboard/credit-score" target="_blank">
              free credit score
            </a>{' '}
            from TransUnion through NerdWallet. It won’t impact your credit and
            NerdWallet will monitor your credit for you.
          </span>
        ),
        trackingId,
      };

  if (isSignedIn) return <CardCta {...propsCardCta} />;

  return (
    <GuideSignUpCta
      {...propsSignUpCta}
      driverLocation="col_membership_cta"
      impressionPayload={impressionPayload}
    />
  );
};

export default COLMembershipCta;
